import { graphql, commitMutation } from 'react-relay';

const mutation = graphql`
    mutation SharedSaveSearchMutation($searchPages: [String], $input: FavoritePageInput!) {
        favoritePage(input: $input) {
            user {
                savedSearches: favorites(first: 1, types: [SEARCH], pages: $searchPages) {
                    edges {
                        node {
                            serviceId
                        }
                    }
                }
            }
        }
    }
`;

function commit(environment, { page, favoritedSearchId, ...props }) {
    const input = {
        page,
        type: 'SEARCH',
        userId: props.userId,
        favoriteId: favoritedSearchId,
        action: favoritedSearchId ? 'REMOVE' : 'ADD',
    };

    commitMutation(environment, {
        mutation,
        variables: {
            input,
            searchPages: page ? [page] : null,
        },
        onCompleted: props.onCompleted,
        onError: props.onError,
    });
}

export default { commit };
